import React from 'react'
import PropTypes from 'prop-types'
import CallToAction from '../../../shared/CallToActionButton'
import SvgIcon from '../../../shared/SvgIcon'
import { Section } from 'src/components/shared/SectionV2'

const CreditCardDebtSimple = ({
  title,
  debtTitle,
  debtText,
  saveTitle,
  saveText,
  enrollTitle,
  enrollText,
  footer,
  button,
  variant = 'primary',
}) => {
  const cards = [
    { title: debtTitle, description: debtText, icon: 'bankCards' },
    { title: saveTitle, description: saveText, icon: 'magnifyingGlass' },
    { title: enrollTitle, description: enrollText, icon: 'document' },
  ]

  return (
    <Section
      variant={variant}
      id="credit-card-debt-simple"
      data-eh-observe="credit-card-debt-relief-is-simple"
    >
      <Section.Typography
        as="h2"
        variant="heading-large"
        data-testid="credit-card-debt-simple-title"
      >
        {title}
      </Section.Typography>

      <div className="mt-8 flex flex-col items-center gap-x-8 gap-y-6 lg:flex-row lg:justify-center">
        {cards.map((card) => (
          <div
            key={card.title}
            className="flex flex-col gap-2 lg:max-w-[341px]"
            data-testid="credit-card-debt-simple-card"
          >
            <SvgIcon
              name={card.icon}
              className="size-20 mx-auto fill-content-accent"
            />
            <Section.Typography
              variant="heading-small"
              data-testid="credit-card-debt-simple-card-title"
            >
              {card.title}
            </Section.Typography>
            <Section.Typography
              variant="body-medium"
              data-testid="credit-card-debt-simple-card-description"
            >
              {card.description}
            </Section.Typography>
          </div>
        ))}
      </div>

      <Section.Typography
        className="mt-6"
        variant="body-medium"
        dangerouslySetInnerHTML={{ __html: footer }}
        data-testid="credit-card-debt-simple-footer"
      />

      <CallToAction
        id="credit-card-debt-simple-cta"
        title={title}
        fontClassName="text-lg font-normal leading-snug tracking-normal text-white"
        className="mt-6 w-full bg-content-accent md:max-w-[327px]"
        text={button.text}
        isLeadId={true}
        withArrow={false}
      />
    </Section>
  )
}

CreditCardDebtSimple.defaultProps = {
  footer: '',
}

CreditCardDebtSimple.propTypes = {
  title: PropTypes.string.isRequired,
  debtTitle: PropTypes.string.isRequired,
  debtText: PropTypes.string.isRequired,
  saveTitle: PropTypes.string.isRequired,
  saveText: PropTypes.string.isRequired,
  enrollTitle: PropTypes.string.isRequired,
  enrollText: PropTypes.string.isRequired,
  footer: PropTypes.string,
  button: PropTypes.object.isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary']),
}

export default CreditCardDebtSimple
